import { render, staticRenderFns } from "./WalletConnect.vue?vue&type=template&id=fddff572&"
import script from "./WalletConnect.vue?vue&type=script&lang=js&"
export * from "./WalletConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports